import "./IsuzuAdvert.css";
import "./IsuzuAdvertResponsive.css";
import "swiper/css";
import "swiper/css/autoplay";

import achievementsData from "../../../assets/data/achievements/achievements.json";
import AchievementCard from "../../../widgets/achievements-card/AchievementCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperType } from "swiper/types";
import { Autoplay } from "swiper/modules";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { useAppContext } from "../../../App";
import parse from "html-react-parser";

function IsuzuAdvert() {
  const appContext = useAppContext();
  const [slideRoute, setSlideRoute] = useState<{
    description: string | undefined;
    link: string | undefined;
    title: string | undefined;
    type: string | undefined;
  }>();

  return (
    <div className="row m-0 isuzu-advert">
      <div className="col-lg-6 col-md-6 col-12 p-0 advert-video-container">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={10}
          slidesPerView={1}
          centeredSlides={false}
          navigation={true}
          speed={800}
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          onSlideChange={({ activeIndex, slides }: SwiperType) => {
            const slideObj = achievementsData.find(
              ({ id }) => id === Number(slides[activeIndex].dataset["id"])
            );
            setSlideRoute({
              ...{
                description: slideObj?.description,
                link: slideObj?.link,
                title: slideObj?.title,
                type: slideObj?.type,
              },
            });
          }}
          className="achievements-swiper"
        >
          {achievementsData.map((item, index) => {
            if (item.type !== "youtube") return null;
            return (
              <SwiperSlide
                key={index}
                className="home-achievement-card"
                data-id={item.id}
              >
                <AchievementCard data={item} key={index} />
              </SwiperSlide>
            );
          })}
        </Swiper>
        <button
          rel="noopener noreferrer"
          className="current-slide-route btn btn-sm btn-danger"
          onClick={() => {
            appContext?.setViewFile({
              path: slideRoute?.link!,
              title: slideRoute?.title,
              type: slideRoute?.type!,
            });
          }}
        >
          <FontAwesomeIcon icon={faPlay} className="text-danger" />
          <span>Open Story</span>
        </button>
      </div>
      <div className="col-lg-6 col-md-6 col-12 isuzu-description">
        <div className="col-12">
          <h1>OUR FARM -</h1>
          <h1>NOW ON SCREEN</h1>
        </div>
        <div className="col-12">
          <h4>
            We’re proud to have our farm recognized by some incredible platforms
            that are helping to tell our story and inspire others:
          </h4>
        </div>
        <div className="col-12 p-0 advert-description">
          <div className="advert-description-wrapper">
            {parse(`${slideRoute?.description!}`)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default IsuzuAdvert;
